module.exports = __webpack_public_path__ + "static/media/I noite de serenatas - Out 2018.9a2e7c35.jpg";